import { render, staticRenderFns } from "./VideoPlayerClappr.vue?vue&type=template&id=af5f082c&scoped=true&"
import script from "./VideoPlayerClappr.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerClappr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5f082c",
  null
  
)

export default component.exports